import React from "react";
import { IPartnershipBrandsProps } from "./PartnershipBrandsProps";
import { StyledLogos, Subtitle, Title } from "./PartnershipBrandsHelpers";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const PartnershipBrands: React.FC<IPartnershipBrandsProps> = (props) => {
  const logos = props.relationships.field_linked_logos || null;
  return (
    <Container fluid="sm" className="pt-3 pb-3 pt-lg-5 pb-lg-5">
      <Row className="justify-content-md-center">
        <Col className="text-center text-lg-left" lg={5}>
          {props.field_subtitle !== null && (
            <Subtitle>{props.field_subtitle}</Subtitle>
          )}
          <Title>{props.field_title}</Title>
          <p
            className="description text-left"
            dangerouslySetInnerHTML={{ __html: props.field_description }}
          />
        </Col>
        <Col>
          <StyledLogos className="mt-3 mt-sm-0">
            {logos &&
              logos.map((logo) => {
                const image =
                  logo.relationships.field_media.relationships.field_media_file
                    .publicUrl;
                return (
                  <Col
                    xs={4}
                    key={logo.id}
                    className="text-center mb-5 d-flex flex-column justify-content-center"
                  >
                    <a
                      href={logo.field_link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={logo.field_link.title}
                    >
                      <img src={image} alt={logo.field_link.title} />
                    </a>
                  </Col>
                );
              })}
          </StyledLogos>
        </Col>
      </Row>
    </Container>
  );
};

export default PartnershipBrands;
